import { render, staticRenderFns } from "./infoImport.vue?vue&type=template&id=7f8a1328&"
import script from "./infoImport.vue?vue&type=script&lang=js&"
export * from "./infoImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports